export default function () {
  return [
            [
          'a',
          'MARKET',
          ':',
          'ready',
          '',
          'title',
          ':',
          'Skill 37',
          '',
          'usage',
          '=',
          '247k',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pa-Social == "project" ) { sa-State = "Ok" } else { sa-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        //         ['2','Post',':','Hello Service World!','','subtitle',':','welcome to ai web','','body',':',
        //         `AI super productivity services.
        // Add incentive check lists to trigger ai innovators worldwide.
        // Or add your services to contribute to world's innovation projects.`,'','signature',':',`clone free ai world apps:
        // github.com/ai-accelerator`,'','','','','','','','','','','\n'],
        [
          'b',
          'RATES',
          ':',
          'money',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pb-Rates == "range" ) { sb-State = "Ok" } else { sb-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'c',
          'DOCS',
          ':',
          'terms',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pc-Docs == "public" ) { sc-State = "Ok" } else { sc-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'd',
          'BOOK',
          ':',
          'done',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pd-Book == "open" ) { sd-State = "Ok" } else { sd-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'e',
          'INPUT',
          ':',
          'test',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pe-Input == "match" ) { se-State = "Ok" } else { se-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'f',
          'STEPS',
          ':',
          'plan',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pf-Steps == "tasks" ) { sf-State = "Ok" } else { sf-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'g',
          'OUTPUT',
          ':',
          'create',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( pg-Output == "tested" ) { sg-State = "Ok" } else { sg-State = "Quit" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'h',
          'PAY',
          ':',
          'paid',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'Click',
          ':',
          '= if ( ph-Pay == "paid" ) { sh-State = "Done" } else { sh-State = "Back" }',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],

  ]
}